export default "__VITE_ASSET__IiyFQrCm__"